module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/active.7d5471ce.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/active.png
// module id = 3058
// module chunks = 11